<template>
  <div class="createaccount--signin-link">
    <p class="content-leadin">
      Have an existing HomeGauge account?
      <router-link :to="signinLink" class="content-link">Sign In</router-link>
    </p>
  </div>
</template>

<script>
import RouteNames from '@/router/constants/route-names';

export default {
  computed: {
    signinLink() {
      return {
        name: RouteNames.AppointmentSignIn,
      };
    },
  },
};
</script>

<style lang="scss">
@import '../styles/vars/theme';

$_vertical-border: 1px solid $theme-color-gray-light;

.createaccount--signin-link {
  border-bottom: $_vertical-border;
  border-top: $_vertical-border;
  padding: 20px 0;

  .content-link {
    margin-left: 4px;
  }
}
</style>
